"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRatingCreateDto = instanceOfShiftRatingCreateDto;
exports.ShiftRatingCreateDtoFromJSON = ShiftRatingCreateDtoFromJSON;
exports.ShiftRatingCreateDtoFromJSONTyped = ShiftRatingCreateDtoFromJSONTyped;
exports.ShiftRatingCreateDtoToJSON = ShiftRatingCreateDtoToJSON;
exports.ShiftRatingCreateDtoToJSONTyped = ShiftRatingCreateDtoToJSONTyped;
const ShiftRatingDto_1 = require("./ShiftRatingDto");
/**
 * Check if a given object implements the ShiftRatingCreateDto interface.
 */
function instanceOfShiftRatingCreateDto(value) {
    if (!('ratings' in value) || value['ratings'] === undefined)
        return false;
    return true;
}
function ShiftRatingCreateDtoFromJSON(json) {
    return ShiftRatingCreateDtoFromJSONTyped(json, false);
}
function ShiftRatingCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ratings': (json['ratings'].map(ShiftRatingDto_1.ShiftRatingDtoFromJSON)),
    };
}
function ShiftRatingCreateDtoToJSON(json) {
    return ShiftRatingCreateDtoToJSONTyped(json, false);
}
function ShiftRatingCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ratings': (value['ratings'].map(ShiftRatingDto_1.ShiftRatingDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftRatingCreateDto.js.map